import React from 'react';

const ReferAndEarn = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 font-sans overflow-hidden">
      {/* Header */}
     <div className="w-screen h-64 md:h-[600px] border-[3px] border-[#35A93E]">
        <img
          src="/refer.jpeg"
          alt="Refer Banner"
          className="w-full h-full object-contain md:object-cover"
        />
      </div>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-12">
        {/* Hero Section */}
        <section className="bg-white rounded-2xl shadow-xl p-8 mb-10 text-center transform hover:scale-[1.01] transition-transform duration-300">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Want to Earn Extra Income While Promoting Better Health?</h2>
          <p className="text-gray-600 leading-relaxed max-w-2xl mx-auto">
            Join the LifeOnPlus Network Marketing Program and turn your contacts into commissions!
          </p>
          <a
            href="https://members.lifeonplus.com/login"
            className="mt-6 inline-block bg-[#35A93E] text-white font-semibold px-8 py-3 rounded-full hover:bg-green-700 transition-colors duration-300"
          >
            Become a Network Partner
          </a>
        </section>

        {/* How It Works Section */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">It’s Simple</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <div className="text-4xl font-bold text-[#35A93E] mb-3">1</div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Refer Your Network</h3>
              <p className="text-gray-600">Share your unique link with friends, family, and your network to introduce them to LifeOnPlus health products or services.</p>
            </div>
            <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <div className="text-4xl font-bold text-[#35A93E] mb-3">2</div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Earn Commissions</h3>
              <p className="text-gray-600">Earn a commission on every successful transaction made through your referrals.</p>
            </div>
            <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <div className="text-4xl font-bold text-[#35A93E] mb-3">3</div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Grow & Unlock Rewards</h3>
              <p className="text-gray-600">Build your team, climb the ranks, and unlock higher rewards and bonuses.</p>
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="bg-gradient-to-r from-[#35A93E] to-green-500 text-white rounded-2xl shadow-xl p-8 mb-10">
          <h2 className="text-3xl font-bold mb-6 text-center">Why Join?</h2>
          <p className="text-center mb-6 leading-relaxed max-w-2xl mx-auto">
            No inventory. No office. Just share your link and build your passive income—right from your phone.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="text-2xl font-semibold mb-2">Free to Join</div>
              <p className="text-sm">Start without any upfront costs.</p>
            </div>
            <div className="text-center">
              <div className="text-2xl font-semibold mb-2">Performance-Based Income</div>
              <p className="text-sm">Earn based on your efforts and results.</p>
            </div>
            <div className="text-center">
              <div className="text-2xl font-semibold mb-2">Transparent Dashboard</div>
              <p className="text-sm">Track your progress with ease.</p>
            </div>
            <div className="text-center">
              <div className="text-2xl font-semibold mb-2">Monthly Incentives</div>
              <p className="text-sm">Unlock bonuses and rewards regularly.</p>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="text-center mb-10">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Start Sharing Health. Start Earning Wealth.</h2>
          <p className="text-gray-600 mb-6 max-w-xl mx-auto">
            Become a LifeOnPlus Network Partner today and take the first step towards building your own passive income stream.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://members.lifeonplus.com/login"
              className="bg-[#35A93E] text-white font-semibold px-8 py-3 rounded-full hover:bg-green-700 transition-colors duration-300"
            >
              Join Now
            </a>
            <a
              href="https://members.lifeonplus.com/login"
              className="bg-white text-[#35A93E] font-semibold px-8 py-3 rounded-full border border-[#35A93E] hover:bg-gray-100 transition-colors duration-300"
            >
              Member Login
            </a>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-gradient-to-r from-[#35A93E] to-green-600 text-white py-6">
        <div className="container mx-auto px-4 text-center">
          <p className="text-sm">© 2025 LifeOnPlus. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default ReferAndEarn;